import { render, staticRenderFns } from "./AirStats.vue?vue&type=template&id=40c5788e&scoped=true&"
import script from "./AirStats.vue?vue&type=script&lang=js&"
export * from "./AirStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c5788e",
  null
  
)

export default component.exports